// extracted by mini-css-extract-plugin
export default {"root":"QuestionMain_root__VLifL","main":"QuestionMain_main__34KlB"};